import {
  INVOICE_SIDEBAR_SET_ID_ACTION,
  INVOICE_SIDEBAR_SET_BILLING_ACCOUNT_ACTION,
  INVOICE_SIDEBAR_SET_USE_CREDIT_ACTION,
  INVOICE_SIDEBAR_SET_PAYPAL_TOKEN_ACTION,
  INVOICE_SIDEBAR_SET_STRIPE_EXPANDED_ACTION,
  INVOICE_SIDEBAR_SET_PAYPAL_EXPANDED_ACTION,
  INVOICE_SIDEBAR_SET_BANKTRANSFER_EXPANDED_ACTION,
} from '../actions/invoice_sidebar';

export type IInvoiceSidebarState = {
  banktransfer_expanded: boolean;
  billing_account_id: number | string | void;
  id: number | string | void;
  paypal_environment: string;
  paypal_expanded: boolean;
  paypal_token: any;
  promotion_code: any;
  stripe_expanded: boolean;
  use_credit: boolean;
};

const defaultState: IInvoiceSidebarState = {
  id: null,
  billing_account_id: null,
  promotion_code: null,
  use_credit: false,
  paypal_token: null,
  paypal_environment: '',
  stripe_expanded: false,
  paypal_expanded: false,
  banktransfer_expanded: false,
};

const reducer = (state = defaultState, action): IInvoiceSidebarState => {
  if (!action || !action.type) return state;

  // eslint-disable-next-line default-case
  switch (action.type) {
    case INVOICE_SIDEBAR_SET_ID_ACTION:
      if (state.id === action.value) return state;
      return { ...state, ...defaultState, id: action.value };

    case INVOICE_SIDEBAR_SET_BILLING_ACCOUNT_ACTION:
      return { ...state, billing_account_id: action.value };

    case INVOICE_SIDEBAR_SET_USE_CREDIT_ACTION:
      return { ...state, use_credit: action.value };

    case INVOICE_SIDEBAR_SET_PAYPAL_TOKEN_ACTION:
      return { ...state, paypal_token: action.token, paypal_environment: action.environment };

    case INVOICE_SIDEBAR_SET_STRIPE_EXPANDED_ACTION:
      return { ...state, stripe_expanded: action.value };

    case INVOICE_SIDEBAR_SET_PAYPAL_EXPANDED_ACTION:
      return { ...state, paypal_expanded: action.value };

    case INVOICE_SIDEBAR_SET_BANKTRANSFER_EXPANDED_ACTION:
      return { ...state, banktransfer_expanded: action.value };
  }

  return state;
};

export default reducer;
